/** @format */
import { BASKET_MPBX_BRIDGE_FEATURE_FLAG } from '@toucan/common/services/feature-flags/constants';

import { useFeatureFlag } from '@toucan/client/global/feature-flag';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type UseBasketFeatureFlagReturn = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    newBasket: boolean;
};

export function useBasketFeatureFlag(): UseBasketFeatureFlagReturn {
    const flag = useFeatureFlag(BASKET_MPBX_BRIDGE_FEATURE_FLAG);

    return {
        newBasket: flag?.isEnabled ?? false,
    };
}
